export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push(value)
    }
  },
  LIST_REMOVE (state, value) {
    const id = typeof value === 'string' ? value : typeof value === 'object' && value.id ? value.id : ''
    const index = state.list.findIndex(c => c.id === id)
    if (index > -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, Object.assign(state.list[index], value))
    } else {
      state.list.push(Object.assign({}, value)) // reason: see fetchModel.js
    }
  },
  CURRENT (state, value) {
    if (value) {
      state.current = value
    } else {
      state.current = {
        id: '',
        apiToken: '',
        apiUrl: '',
        subscription: 0,
        user: null
      }
    }
    state.update.apiToken = state.current.apiToken
    state.update.apiUrl = state.current.apiUrl
    state.update.subscription = state.current.subscription
    state.update.user = state.current.user
  },
  UPDATE_API_TOKEN (state, value) {
    state.update.apiToken = value
  },
  UPDATE_API_URL (state, value) {
    state.update.apiUrl = value
  },
  UPDATE_SUBSCRIPTION (state, value) {
    state.update.subscription = value
  },
  UPDATE_USER (state, value) {
    state.update.user = value
  }
}
